import { useFormContext } from "react-hook-form";
import Input from "../../../UI/Input";

export default function UserCallsignField() {
    const { register, formState } = useFormContext();
    const error = formState.errors.callsign;

    return (
        <div>
            <Input
                type="text"
                grayStyle
                placeholder="Позывной"
                className={`universaleditmodal-right-content${error ? "-invalid" : ""}`}
                {...register("callsign", { minLength: 3, maxLength: 40 })}
            />
            {error?.type === "minLength" && (
                <p className="universaleditmodal-right-content-invalid-message">
                    Мин. 3 символа
                </p>
            )}
            {error?.type === "maxLength" && (
                <p className="universaleditmodal-right-content-invalid-message">
                    Макс. 40 символов
                </p>
            )}
        </div>
    );
}
